<template>
    <div id="shortlistPage">
        <Menu topIndex="shortlistPage"></Menu>
        
        <div class="contentBox">
            <div class="clearfix contentBox-top">
                <div class="title">入选名单</div>
            </div>
            <div class="contentFormBox">
              <p class="actName">{{ actResultObj.name }}</p>
              <p class="actResult" v-html="actResultObj.actResult"></p>
              <p class="actResult">以下为入选名单：</p>
              <el-table
                :data="myShenBaoData"
                v-loading="tableLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-customClass="loadingStyles"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
              >
                <!-- <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column> -->
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="name"
                  min-width="80"
                  label="成果名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="series"
                  min-width="80"
                  label="所属系列"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="subject"
                  show-overflow-tooltip
                  label="所属学科"
                  min-width="70px"
                  align="center"
                >
                </el-table-column
                >
                <el-table-column
                  prop="applyName"
                  show-overflow-tooltip
                  label="申请人"
                  min-width="70px"
                  align="center"
                >
                </el-table-column
                >
                <el-table-column
                  prop="form"
                  show-overflow-tooltip
                  label="成果形式"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <!-- 主列表分页 -->
              <!-- <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize"
                >
                </el-pagination>
              </div> -->
            </div>
        </div>  
    </div>
</template>

<script>
  import '@/assets/css/index.css';
  import Menu from "@/views/component/topMenu.vue";
  import $ from 'jquery'; 
  
  export default {
    data() {
      return {
        formInline: {
          user: '',
          region: ''
        },
        collaboratorsTable:[],
        addCollaboratorsDialog:false,
        addCollaboratorsForm:{},
        fileList: [],
        myShenBaoData:[],
        tableLoading: false,
        multipleSelectionTable: [],
        currentPage: 1,
        pageSize: 10,
        totalSize: 0,
        actInfo: {},
        actResultObj:{}
      }
    },
    mounted() {
      var that = this;
      document.title = '入选名单';
      $.ajax({
            url: '/zxzg/api/vh/free/act/actInfo/list',
            type: "GET",
            dataType: "json",
            error: (xhr) => {
                if (xhr.status == 401) window.location.reload();
                else console.error('请求失败',xhr);
            },
            success: (data) => {
                if(data.code === 200) {
                  that.actInfo = data.obj.list[0];

                  //  this.actId = data.obj.list[0].id;
                    $.ajax({
                      url: '/zxzg/api/vh/free/act/actResult/list',
                      type: "POST",
                      dataType: "json",
                      data: {
                          actId: data.obj.list[0].id,
                      },
                      error: (xhr) => {
                          if (xhr.status == 401) window.location.reload();
                          else console.error('请求失败',xhr);
                      },
                      success: (data) => {
                          if(data.code === 200) {
                            that.actResultObj = data.obj;
                            that.myShenBaoData = data.obj.submitInfos;
                          }else{
                              this.$message({
                                  message: data.msg,
                                  duration: 0,
                                  showClose: true,
                                  type: "error",
                                  offset: 100,
                              });
                          }
                      }
                  })
                }else{
                    this.$message({
                        message: data.msg,
                        duration: 20000,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            }
        })

    },
    components: {
        Menu,
    },
    methods: {
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchParam();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchParam();
        },
        
        // 选择表格某一行
        handleTableSelectionChange(val) {
        this.multipleSelectionTable = val;
        },
    }
  }
</script>

<style scoped>
  .actName{
    font-size: 24px;
    font-weight: bolder;
    text-align: center;
    margin: 20px auto 30px;
  }
  .actResult{
    line-height: 2.3em;
  }
  
  .contentFormBox{
    padding: 0 80px;
    width: auto;
  }
  @media (max-width: 600px) {
    .contentFormBox{
      padding: 0;
    }
  }

</style>